<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="vendor.company_id && vendor.company_id > 0"
                                @invoke-method="dbGetVendor(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="vendor.company_id && vendor.company_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('vendors.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in vendor_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != vendor.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('vendors.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_vendor.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'vendors' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="vendor.status" class="ribbon ribbon-top-right" :class="`ribbon-${vendor.status_class}`"><span class="ribbon-span">{{ vendor.status }}</span></div>
                        <v-form ref="formVendor">
							<v-flex xs12>
								<v-text-field
									v-focus="vendor_dialog"
									v-model="vendor.company_id"
									:label="$t('lang.company_id')"
									:counter="showCounter(vendor.company_id, 'vendors.company_id')"
									:rules="ifValid('vendors.company_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.parent_id"
									:label="$t('lang.parent_id')"
									:counter="showCounter(vendor.parent_id, 'vendors.parent_id')"
									:rules="ifValid('vendors.parent_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.stripe_id"
									:label="$t('lang.stripe_id')"
									:counter="showCounter(vendor.stripe_id, 'vendors.stripe_id')"
									:rules="ifValid('vendors.stripe_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.zoho_customer_id"
									:label="$t('lang.zoho_customer_id')"
									:counter="showCounter(vendor.zoho_customer_id, 'vendors.zoho_customer_id')"
									:rules="ifValid('vendors.zoho_customer_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.organisation_type_id"
									:label="$t('lang.organisation_type_id')"
									:counter="showCounter(vendor.organisation_type_id, 'vendors.organisation_type_id')"
									:rules="ifValid('vendors.organisation_type_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.company"
									:label="`${$t('lang.company')} *`"
									:counter="showCounter(vendor.company, 'vendors.company')"
									:rules="ifValid('vendors.company')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.company_short"
									:label="$t('lang.company_short')"
									:counter="showCounter(vendor.company_short, 'vendors.company_short')"
									:rules="ifValid('vendors.company_short')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.website"
									:label="$t('lang.website')"
									:counter="showCounter(vendor.website, 'vendors.website')"
									:rules="ifValid('vendors.website')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.correspondence_method"
									:label="`${$t('lang.correspondence_method')} *`"
									:counter="showCounter(vendor.correspondence_method, 'vendors.correspondence_method')"
									:rules="ifValid('vendors.correspondence_method')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.currency_code"
									:label="`${$t('lang.currency_code')} *`"
									:counter="showCounter(vendor.currency_code, 'vendors.currency_code')"
									:rules="ifValid('vendors.currency_code')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.exchange_rate_id"
									:label="`${$t('lang.exchange_rate_id')} *`"
									:counter="showCounter(vendor.exchange_rate_id, 'vendors.exchange_rate_id')"
									:rules="ifValid('vendors.exchange_rate_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="vendor.payment_term_id"
									:label="$t('lang.payment_term')"
									:items="payment_terms"
									item-value="payment_term_id"
									item-text="payment_term_id"
									:rules="ifValid('vendors.payment_term_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.turn_around_days"
									:label="$t('lang.turn_around_days')"
									:counter="showCounter(vendor.turn_around_days, 'vendors.turn_around_days')"
									:rules="ifValid('vendors.turn_around_days')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="vendor.has_nda"
									:label="`${$t('lang.has_nda')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('vendors.has_nda')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="vendor.has_contract"
									:label="`${$t('lang.has_contract')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('vendors.has_contract')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.ship_label_type"
									:label="`${$t('lang.ship_label_type')} *`"
									:counter="showCounter(vendor.ship_label_type, 'vendors.ship_label_type')"
									:rules="ifValid('vendors.ship_label_type')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="vendor.notes"
									:label="$t('lang.notes')"
									auto-grow
									rows="1"
									:rules="ifValid('vendors.notes')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.logo_id"
									:label="$t('lang.logo_id')"
									:counter="showCounter(vendor.logo_id, 'vendors.logo_id')"
									:rules="ifValid('vendors.logo_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.packing_list_fields"
									:label="$t('lang.packing_list_fields')"
									:counter="showCounter(vendor.packing_list_fields, 'vendors.packing_list_fields')"
									:rules="ifValid('vendors.packing_list_fields')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="vendor.logo"
									:label="$t('lang.logo')"
									:counter="showCounter(vendor.logo, 'vendors.logo')"
									:rules="ifValid('vendors.logo')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="vendor.status"
									:label="`${$t('lang.status')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('vendors.status')"
								></bc-select>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'vendors' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveVendors">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_vendor"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_vendor')"
                :message="$t('lang.delete_vendor_confirm')"
                @onConfirm="deleteVendors()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_vendor_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteVendorDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            vendor: {},
            file_name: "",
            dbGetVendor: _.debounce(this.getVendor, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchVendor", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.vendor) {
                        this.vendor = this.assignObj2(data.vendor, this.rules_vendors);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=vendor_status&sort_by=2",
                            method: "get",
                            stateProperty: "vendor_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "vendors", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchVendor", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.vendor) {
                        next((vm) => {
                            vm.vendor = vm.assignObj2(data.vendor, vm.rules_vendors);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=vendor_status&sort_by=2",
                                method: "get",
                                stateProperty: "vendor_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "vendors", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=vendor_status&sort_by=2",
            method: "get",
            stateProperty: "vendor_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_vendors: (state) => state.vendors.rules_vendors,
            vendor_status_options: (state) => state.settings.vendor_status_options,
            vendors: (state) => state.vendors.vendors,
            selectedVendor: (state) => state.vendors.selectedVendor,
            payment_terms: (state) => state.payment_terms.payment_term_options,
        }),
    },
    methods: {
        ...mapActions(["fetchVendor", "saveVendor", "deleteVendor", "printVendor", "fetchPaymentTerms"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getVendor(pg_refresh = false) {
            this.startLoader();

            this.fetchVendor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.vendor) {
                    this.vendor = this.assignObj2(data.vendor, this.rules_vendors);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printVendor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.vendor) {
                    if (this.dev_mode) {
                        this.file_name = data.vendor.file_name;
                    } else {
                        this.$refs.print.printReport(data.vendor.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveVendors() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formVendor")) {
                    let body = this.prepForm(this.vendor, this.rules_vendors);

                    this.saveVendor({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.vendor) {
                            this.$router.push({ name: "vendor", params: { id: data.vendor.company_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { company_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveVendors({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.vendor) {
                    this.vendor = this.assignObj2(data.vendor, this.rules_vendors);
                }
            });
        },
        deleteVendors() {
            this.deleteVendor({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "vendors" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchVendor({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.vendor) {
                        this.vendor = this.assignObj2(data.vendor, this.rules_vendors);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.payment_terms.length == 0 || force == true) await this.fetchPaymentTerms({ body: { options: 1 } });
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
